import moment from "moment"
import XLSX from 'xlsx';
import $axios from '@/axios/config.js'
import { Message } from 'element-ui'

const formatDate = () => {
  let date = moment(new Date())
  const season = date.quarter() - 1 <= 1 ? 'Q1' : 'Q' + (date.quarter() - 1)
  return {
    season,
    year: '' + date.year(),
    month: '' + date.month()
  }
}
export default {

  defaultMonth: formatDate().month,
  defaultYear: formatDate().year,
  defaultSeason: formatDate().season,
  defaultYear2: '2017',
  baseUrl: 'http://dlite3.basf.com/',
  currentYear (list, name, id) {
    let date = new Date()
    let year = date.getFullYear()
    let yearId = null
    list.some(item => {
      if (item[name]/1 === year) {
        yearId = item[id]
      }
    })
    return yearId
  },
  lastestYear (list, name, id) {
    let date = new Date()
    let year = date.getFullYear() - 1
    let yearId = null
    list.some(item => {
      if (item[name]/1 === year) {
        yearId = item[id]
      }
    })
    return yearId
  },
  toolBox (name) {
    return {
      feature: {
        saveAsImage: {
          name: name,
          title: ' ',
          pixelRatio: 2,
          iconStyle: {
            borderColor: '#21bdbd',
            borderWidth: 2
          }
        }
      }
    }
  },

  canDownload (name) {
    if (name && sessionStorage.allOperationArr) {
      if (sessionStorage.allOperationArr.indexOf(name) != -1) {
        return true
      } else {
        return false
      }
    }
  },

  removePX (str) {
    console.log(str)
    var num = str.replace('px', '')
    return parseInt(num)
  },
  addPX (num) {
    return num + 'PX'
  },

  trim (str) {
    if (str) {
      return str.replace(/(^\s*)|(\s*$)/g, '')
    } else {
      return str
    }
  },

  // 获取日期前范围 例：2018.12.12-2019.01.11
  datarange (day) {
    // 获取当前日期
    var myDate = new Date()
    var nowY = myDate.getFullYear()
    var nowM = myDate.getMonth() + 1
    var nowD = myDate.getDate()
    var enddate = nowY + '.' + (nowM < 10 ? '0' + nowM : nowM) + '.' + (nowD < 10 ? '0' + nowD : nowD)// 当前日期

    // 获取三十天前日期
    var lw = new Date(myDate - 1000 * 60 * 60 * 24 * day)// 最后一个数字30可改，30天的意思
    var lastY = lw.getFullYear()
    var lastM = lw.getMonth() + 1
    var lastD = lw.getDate()
    var startdate = lastY + '.' + (lastM < 10 ? '0' + lastM : lastM) + '.' + (lastD < 10 ? '0' + lastD : lastD)// 三十天之前日期

    return startdate + '-' + enddate
  },
  // 获取某一年份到当前年份的所有年份
  yearrange (startYear = 2012) {
    var myDate = new Date()
    var thisYear = myDate.getFullYear() // 获取当年年份
    var Section = thisYear - startYear // 声明一个变量 获得当前年份至想获取年份差 eg.2008
    var arrYear = [] // 声明一个空数组 把遍历出的年份添加到数组里
    for (var i = 0; i <= Section; i++) {
      arrYear.push(thisYear-- + '')
    }
    return arrYear
  },
  yearrange2 (startYear = 2012) {
    var myDate = new Date()
    var thisYear = myDate.getFullYear() + 3 // 获取当年年份
    var Section = thisYear - startYear // 声明一个变量 获得当前年份至想获取年份差 eg.2008
    var arrYear = [] // 声明一个空数组 把遍历出的年份添加到数组里
    for (var i = 0; i <= Section; i++) {
      arrYear.push(thisYear-- + '')
    }
    return arrYear
  },

  timeago (dateTimeStamp) {
    var minute = 1000 * 60 // 把分，时，天，周，半个月，一个月用毫秒表示
    var hour = minute * 60
    var day = hour * 24
    var week = day * 7
    var halfamonth = day * 15
    var month = day * 30

    var now = new Date().getTime() // 获取当前时间毫秒
    var diffValue = now - dateTimeStamp // 时间差

    if (diffValue < 0) {
      return
    }

    var minC = diffValue / minute // 计算时间差的分，时，天，周，月
    var hourC = diffValue / hour
    var dayC = diffValue / day
    var weekC = diffValue / week
    var monthC = diffValue / month

    if (minC >= 1) {
      result = ' ' + parseInt(minC) + '分钟前'
    } else if (hourC >= 1) {
      result = ' ' + parseInt(hourC) + '小时前'
    } else if (dayC >= 1) {
      result = ' ' + parseInt(dayC) + '天前'
    } else if (weekC >= 1) {
      result = ' ' + parseInt(weekC) + '周前'
    } else if (monthC >= 1) {
      result = ' ' + parseInt(monthC) + '月前'
    } else {
      result = '刚刚'
    }
    return result
  },

  numFormat (strNum) {
    strNum = Math.round(strNum * 100000) / 100000
    if (strNum.length <= 3) {
      return strNum
    }
    if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
      return strNum
    }
    var a = RegExp.$1,
      b = RegExp.$2,
      c = RegExp.$3
    var re = new RegExp()
    re.compile('(\\d)(\\d{3})(,|$)')
    while (re.test(b)) {
      b = b.replace(re, '$1,$2$3')
    }
    return a + '' + b + '' + c
  },

  U (locale) {
    return locale.slice(0, 1).toUpperCase() + locale.slice(1)
  },
  randomString (len) {
    len = len || 32
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length
    var pwd = ''
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  }
}
/**
 * 导出echart图表对应的图片
 * @param {chart} chart: echart实例对象
 * @param {String} fileName: 'Personal Care Retail Market Overview'
 * */
export function exportChartImg(chart, fileName) {
  let picInfo=chart.getDataURL({
      type: 'png',
      pixelRatio: 1.5,  //放大两倍下载，之后压缩到同等大小展示。解决生成图片在移动端模糊问题
      backgroundColor: '#fff'
  });//获取到的是一串base64信息
  const elink = document.createElement('a');
  if ('msSaveOrOpenBlob' in navigator) {
    // Microsoft Edge and Microsoft Internet Explorer 10-11
    const bstr = atob(picInfo.split(',')[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    const blob = new Blob([u8arr])
    window.navigator.msSaveOrOpenBlob(blob, decodeURIComponent(fileName) + '.png')
  } else {
    // standard code for Google Chrome, Mozilla Firefox etc
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = picInfo
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
  }
}

/**
 * 导出Excel的处理函数--针对table
 * @param {Array} headers: [{key: 'date', title: '日期'}, {key: 'name', title: '名称'}]
 * @param {Array} data   : [{date: '2019-05-31', name: 'megen.huang'}, {date: 'name', name: '小明'}]
 * @param {String} fileName: '导出结果.xlsx'
 * @param {String} url: '导出记录日志请求接口的url'
 * */
export function ExportExcel(headers, data, fileName, url, params) {
  if(!data.length){
    Message.warning(window.$lang('txt.noDataExport'))
    return
  }
  const _headers = headers
      .map((item, i) => Object.assign({}, { key: item.key, title: item.title, position: i > 25 ? (String.fromCharCode(65 + Math.floor(i / 25) - 1)) + String.fromCharCode(65 + i - 26) + 1 : String.fromCharCode(65 + i) + 1 }))
      .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { key: next.key, v: next.title } }), {});
  const _data = data
      .map((item, i) => headers.map((key, j) => Object.assign({}, { content: item[key.key], position: (j > 25 ? (String.fromCharCode(65 + Math.floor(j / 25) - 1)) + String.fromCharCode(65 + j - 26) : String.fromCharCode(65 + j)) + (i + 2) })))
      // 对刚才的结果进行降维处理（二维数组变成一维数组）
      .reduce((prev, next) => prev.concat(next))
      // 转换成 worksheet 需要的结构
      .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { v: next.content } }), {});
  // 合并 headers 和 data
  const output = Object.assign({}, _headers, _data);
  // 获取所有单元格的位置
  const outputPos = Object.keys(output);
  // 计算出范围 ,["A1",..., "H2"]
  const ref = `${outputPos[0]}:${outputPos[outputPos.length - 1]}`;

  // 构建 workbook 对象
  const wb = {
      SheetNames: ['sheet'],
      Sheets: {
        sheet: Object.assign(
              {},
              output,
              {
                  '!ref': ref,
                  // eslint-disable-next-line
                  '!cols': headers.map(item => ({wpx: 100}))
              }
          )
      }
  };

  // 导出 Excel
  if (url) {
    $axios({
      url,
      method: 'post',
      data: {
        offset: 0,
        size: data.length,
        ...params
      }
    }).then(res => {
      if (res) {
        XLSX.writeFile(wb, fileName)
      }
    }).catch(e => {
    })
  } else {
    XLSX.writeFile(wb, fileName);
  }
}





function formatExcelData(dataObject) {
  const _headers = dataObject.headers
    .map((item, i) => Object.assign({}, { key: item.key, title: item.title, position: i > 25 ? (String.fromCharCode(65 + Math.floor(i / 25) - 1)) + String.fromCharCode(65 + i - 26) + 1 : String.fromCharCode(65 + i) + 1 }))
    .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { key: next.key, v: next.title } }), {});
  const _data = dataObject.data && dataObject.data.length ? dataObject.data
    .map((item, i) => dataObject.headers.map((key, j) => Object.assign({}, { content: item[key.key], position: (j > 25 ? (String.fromCharCode(65 + Math.floor(j / 25) - 1)) + String.fromCharCode(65 + j - 26) : String.fromCharCode(65 + j)) + (i + 2) })))
    // 对刚才的结果进行降维处理（二维数组变成一维数组）
    .reduce((prev, next) => prev.concat(next))
    // 转换成 worksheet 需要的结构
    .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { v: next.content } }), {}) : {}
  // 合并 headers 和 data
  const output = Object.assign({}, _headers, _data);
  // 获取所有单元格的位置
  const outputPos = Object.keys(output);
  // 计算出范围 ,["A1",..., "H2"]
  const ref = `${outputPos[0]}:${outputPos[outputPos.length - 1]}`;

  return Object.assign(
    {},
    output,
    {
        '!ref': ref,
        // eslint-disable-next-line
        '!cols': dataObject.headers.map(item => ({wpx: 100}))
    }
  )
}


export function ExportMultipleSheetExcel(options, fileName, url, size, params) {
  let SheetNames = []
  let Sheets = {}
  options.forEach(v => {
    SheetNames.push(v.sheetName)
    Sheets[v.sheetName] = formatExcelData(v)
  })
  console.log(Sheets)
  // 构建 workbook 对象
  const wb = {
      SheetNames,
      Sheets
  };
  // 导出 Excel
  const lang = localStorage.lang
  const message = {
    'en': 'Downloading',
    'cn': '开始下载',
    'jp': 'ダウンロード中'
  }
  if (url) {
    $axios({
      url,
      method: 'post',
      data: {
        offset: 0,
        size: size || 0,
        ...params
      }
    }).then(res => {
      if (res) {
        XLSX.writeFile(wb, fileName);
        Message.success(message[lang])
      }
    }).catch(e => {
    })
  } else {
    XLSX.writeFile(wb, fileName);
    Message.success(message[lang])
  }
}

export function getLastestDate () {
  let res = moment().quarter(moment().quarter() - 1).startOf('quarter')
  return {
    year: res.year(),
    quarter: res.quarter()
  }
}

export function hasPermission (id) {
  const authList = sessionStorage.getItem('authList')
    ? JSON.parse(sessionStorage.getItem('authList')) : {}
  const menuList = authList.menu || []
  const hasPermission = menuList.includes(id)
  if (!hasPermission) {
    const lang = localStorage.lang
    const message = lang === 'en'
      ? "Can't view this module, please ask for customer service for more authority"
      : '无此模块权限，如需查看请联系客户服务申请权限'
    Message.error(message)
    return false
  }
  return true
}

export function formatNumToThousand (n) {
  let res = ''
  // 检查传入数值为数值类型
  if (isNaN(n)) {
    return 0
  }
  try {
    if (Number(n) < 10) {
      return '<10'
    }
    const s = n.toString()
    const length = s.length
    for (let i = length - 1; i >= 0; i--) {
      const j = length - i
      if (j % 3 === 0) {
        if (i === 0) {
          res = s[i] + res
        } else {
          res = ',' + s[i] + res
        }
      } else {
        res = s[i] + res
      }
    }
  } catch (e) {}
  return res
}



// WEBPACK FOOTER //
// ./src/utils/index.js